export enum ServiceTemplateRecurrenceOccurrenceStatus {
    SCHEDULED = "SCHEDULED",
    SKIPPED = "SKIPPED",
    APPLIED = "APPLIED",
}
